
function f_circle_check() {
    const badges = document.querySelectorAll('.circle-badge-container');
    
    if (badges.length === 0) return;

    let maxBadgeSize = 0;

    badges.forEach(badge => {
        badge.classList.remove('circle-badge-fixed');
        badge.classList.add('circle-badge-measuring');
    });

    badges.forEach(badge => {
        const rect = badge.getBoundingClientRect();
        const naturalSize = Math.max(rect.width, rect.height);
        if (naturalSize > maxBadgeSize) {
            maxBadgeSize = naturalSize;
        }
    });

    if (maxBadgeSize > 0) {
        const sizePx = `${maxBadgeSize}px`;
        
        badges.forEach(badge => {
            badge.style.setProperty('--uniform-badge-size', sizePx);
            badge.classList.remove('circle-badge-measuring');
            badge.classList.add('circle-badge-fixed');
        });
    }
}

// --- SHOPIFY EXECUTION LOGIC ---

// 1. Run when the full window (images/styles) is ready
window.addEventListener('load', f_circle_check);

// 2. Run when a section is reloaded in the Theme Editor (Customizer)
document.addEventListener('shopify:section:load', f_circle_check);

// 3. Run if the page uses "Search & Discovery" filters (AJAX)
// Most Shopify apps/themes trigger a 'collection:reloaded' or 'page:loaded' event
document.addEventListener('ajaxy:success', f_circle_check); // Common custom event
